import React from 'react';
import classNames from 'classnames';

// Components
import Modal from '@/views/components/modals/AccessibleModal';

type Props = {
  children: JSX.Element | JSX.Element[];
  className?: string;
  show: boolean;
  onExited?: () => void;
};

const FullPageModal = ({ children, className, show, onExited }: Props) => (
  <Modal
    animation={false}
    backdrop="static"
    backdropClassName="modal-full-v2-backdrop"
    className={classNames('modal-full-v2', className)}
    dialogClassName="modal-dialog-centered"
    keyboard={false}
    onExited={() => onExited && onExited()}
    show={show}
  >
    {children}
  </Modal>
);

export default FullPageModal;
